import type { ConnectionType } from '@ukrop-nm/shared';

/** Own SVG channel icons (not third-party assets). */
export function ChannelTypeIcon({
  type,
  size = 22,
}: {
  type?: ConnectionType | null;
  size?: number;
}) {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 32 32',
    fill: 'none' as const,
    'aria-hidden': true as const,
    className: 'ukrop-channel-icon',
  };

  switch (type) {
    case 'ethernet':
      // Twisted-pair: RJ45 plug + jack (inspired by common ethernet motif)
      return (
        <svg {...common}>
          <g stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round">
            {/* plug */}
            <path d="M4 8h8v3H4z" />
            <path d="M5.2 8V5.8h1.2V8M7.4 8V5.8h1.2V8M9.6 8V5.8h1.2V8" />
            <path d="M5 11h6v7.5c0 1.2-.8 2-2 2.2h-2c-1.2-.2-2-1-2-2.2V11z" />
            <path d="M8 20.5V26" strokeLinecap="round" />
            {/* jack */}
            <rect x="17" y="8" width="11" height="14" rx="1.5" />
            <rect x="19.2" y="10.2" width="6.6" height="8" rx="0.8" />
            <path d="M21 18.2h3.2v2.2c0 .7-.5 1.1-1.1 1.2h-1c-.6-.1-1.1-.5-1.1-1.2v-2.2z" />
          </g>
        </svg>
      );
    case 'wifi':
      return (
        <svg {...common}>
          <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" fill="none">
            <path d="M8 14c5-5 11-5 16 0" />
            <path d="M11 17.5c3.2-3 6.8-3 10 0" />
            <path d="M13.8 21c1.5-1.4 2.9-1.4 4.4 0" />
            <circle cx="16" cy="24.2" r="1.4" fill="currentColor" stroke="none" />
          </g>
        </svg>
      );
    case 'fiber':
      return (
        <svg {...common}>
          <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
            <circle cx="10" cy="16" r="4.5" />
            <circle cx="10" cy="16" r="1.6" fill="currentColor" stroke="none" />
            <path d="M14.5 16H28" />
            <path d="M24 13l4 3-4 3" strokeLinejoin="round" />
          </g>
        </svg>
      );
    case 'wan':
      return (
        <svg {...common}>
          <g stroke="currentColor" strokeWidth="1.7" fill="none">
            <circle cx="16" cy="16" r="10" />
            <path d="M6 16h20M16 6c3.5 3.2 3.5 16.8 0 20M16 6c-3.5 3.2-3.5 16.8 0 20" />
          </g>
        </svg>
      );
    case 'sip':
      return (
        <svg {...common}>
          <g stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round">
            <path d="M8 11c0-1.4.9-2.4 2.3-2.4h2c1 0 1.5.7 1.5 1.7V13H10.5C9 13 8 12.2 8 11z" />
            <rect x="12" y="11" width="12" height="13" rx="1.8" />
            <rect x="14.2" y="13" width="7.6" height="4" rx="0.6" />
          </g>
        </svg>
      );
    case 'logical':
      return (
        <svg {...common}>
          <g stroke="currentColor" strokeWidth="1.7" strokeLinecap="round">
            <circle cx="8" cy="16" r="3" />
            <circle cx="24" cy="16" r="3" />
            <path d="M11 16h10" strokeDasharray="2.5 2" />
          </g>
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <g stroke="currentColor" strokeWidth="1.7" strokeLinecap="round">
            <path d="M7 16h18" strokeDasharray="3 2.5" />
            <circle cx="7" cy="16" r="2.2" />
            <circle cx="25" cy="16" r="2.2" />
          </g>
        </svg>
      );
  }
}
